import { lazy } from '@cobliteam/lazy-with-retries';

import { Location } from '@cobliteam/common-types';

const RoadSpeedPage = lazy(() => import('../pages/RoadSpeedPage'));

const routes = [{ path: Location.ROAD_SPEED, component: RoadSpeedPage, featureFlag: 'roadSpeedPage' }];

export default routes;
